/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_shipmentQuote = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipmentQuote" | "PdpRespShippingReturns_shipmentQuote">;
    readonly " $refType": "PdpRespContainer_shipmentQuote";
};
export type PdpRespContainer_shipmentQuote$data = PdpRespContainer_shipmentQuote;
export type PdpRespContainer_shipmentQuote$key = {
    readonly " $data"?: PdpRespContainer_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipmentQuote">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_shipmentQuote",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_shipmentQuote",
      "args": null
    }
  ]
};
(node as any).hash = 'efb9d699ed292459b86b63bb220d8246';
export default node;
